<template>
  <div @click="click" class="column-data">
    <span class="title" v-if="column.title">{{column.title}}</span>
    <span class="status">{{parseDate(row[column.field])}}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataItem',
  props: ['column', 'row'],
  methods: {
    parseDate (value) {
      if (!value) {
        return '-'
      }
      if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      try {
        return moment(Number.parseInt(value)).format('DD/MM/YYYY')
      } catch (ignored) {
        return moment(value).format('DD/MM/YYYY')
      }
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
